import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { RouterLink } from '@angular/router';
import { PDSService } from '../../../services/pds.service';

@Component({
  selector: 'app-israel',
  standalone: true,
  imports: [
    RouterLink,
    FooterComponent,
    StaticSearchComponent,
    CommonHeaderComponent,
  ],
  templateUrl: './middleeastconflict.component.html',
  styleUrl: './middleeastconflict.component.scss',
})
export class MiddleEastConflictComponent {
  partnerCode: string = '';
  constructor(
    private titleService: Title,
    private metaService: Meta,
    public pdsService: PDSService,
  ) {
    this.titleService.setTitle(
      'Middle East Conflict Travel Advisory | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content:
        'Stay informed on travel safety amid the Middle East conflict. Get the latest advisory updates and coverage with World2Cover.',
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Middle East Conflict Travel Advisory | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'Stay informed on travel safety amid the Middle East conflict. Get the latest advisory updates and coverage with World2Cover.',
    });
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
  }
}
